import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home, Phone, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const ThankYouPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Trigger Google Ads conversion tracking
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-CONVERSION_ID/CONVERSION_LABEL'
      });
    }

    // Scroll to top
    window.scrollTo(0, 0);
  }, []);

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-red-50/20 flex items-center justify-center p-4">
      <div className="container mx-auto max-w-2xl">
        <Card className="border-2 border-gray-200 shadow-2xl">
          <CardContent className="p-8 md:p-12 text-center">
            {/* Success Icon */}
            <div className="mb-6 flex justify-center">
              <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
                <CheckCircle className="h-12 w-12 text-green-600" />
              </div>
            </div>

            {/* Logo */}
            <div className="mb-6 flex justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_red-sails-storage/artifacts/p7p4c6x9_RSSS%20Logo%202.jpg"
                alt="Red Sail Self Storage Logo"
                className="h-16 w-16 object-contain"
                style={{ width: '64px', height: '64px' }}
              />
            </div>

            {/* Thank You Message */}
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Thank You for Your Enquiry!
            </h1>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We've received your message and will be in touch shortly. 
              Our team typically responds within 24 hours during business hours.
            </p>

            {/* Contact Info Cards */}
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              <div className="p-4 bg-red-50 rounded-lg">
                <div className="flex items-center justify-center space-x-3">
                  <Phone className="h-5 w-5 text-red-600" />
                  <div className="text-left">
                    <p className="text-xs text-gray-600">Call us now</p>
                    <a href="tel:01255823031" className="text-sm font-semibold text-red-600 hover:underline">
                      01255 823031
                    </a>
                  </div>
                </div>
              </div>
              <div className="p-4 bg-red-50 rounded-lg">
                <div className="flex items-center justify-center space-x-3">
                  <Mail className="h-5 w-5 text-red-600" />
                  <div className="text-left">
                    <p className="text-xs text-gray-600">Email us</p>
                    <a href="mailto:redsailselfstorage@gmail.com" className="text-sm font-semibold text-red-600 hover:underline break-all">
                      redsailselfstorage@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Return to Homepage Button */}
            <Button
              onClick={handleGoHome}
              size="lg"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <Home className="h-5 w-5 mr-2" />
              Return to Homepage
            </Button>

            {/* Additional Info */}
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                <strong>Business Hours:</strong> Daily 9:00 AM - 5:00 PM
              </p>
              <p className="text-sm text-gray-600 mt-2">
                <strong>Container Access:</strong> Daily 7:00 AM - 7:00 PM
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Trust Indicators */}
        <div className="mt-8 grid grid-cols-3 gap-4 text-center">
          <div className="bg-white rounded-lg p-4 shadow">
            <p className="text-2xl font-bold text-red-600">100%</p>
            <p className="text-xs text-gray-600">Weatherproof</p>
          </div>
          <div className="bg-white rounded-lg p-4 shadow">
            <p className="text-2xl font-bold text-red-600">Secure</p>
            <p className="text-xs text-gray-600">Lock Box</p>
          </div>
          <div className="bg-white rounded-lg p-4 shadow">
            <p className="text-2xl font-bold text-red-600">£29.98</p>
            <p className="text-xs text-gray-600">From /week</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
